import { SyncLoader } from 'components/loaders/SyncLoader'
import styled from 'styled-components'

export const StyledSyncLoader = styled(SyncLoader).attrs(({ theme }) => ({
  color: theme.color.actionVariant,
}))({})
